import { CustomizedDxColumn } from '..';
import DataGrid2 from '../../..';
import { IComboBoxProperties } from '../../../../ComboBox/entities/IComboBoxProperties';
import { IDataGridColumn } from '../../../entities';
import { CellComponent } from './CellComponent';
import { EditCellComponent } from './EditCellComponent';
import { calculateCellValue } from './calculateCellValue';
import { calculateDisplayValue } from './calculateDisplayValue';
import {
	calculateFilterExpression,
	calculateFilterExpressionDynamic,
	filterOperations
} from './calculateFilterExpression';

export const setComboBox = (
	dataGrid: DataGrid2,
	bcColumn: IDataGridColumn<IComboBoxProperties>,
	dxColumn: CustomizedDxColumn
) => {
	dxColumn.cellComponent = CellComponent;
	dxColumn.editCellComponent = EditCellComponent;
	dxColumn.calculateDisplayValue = calculateDisplayValue;

	if (bcColumn.dbType.type === 'object') {
		dxColumn.calculateCellValue = calculateCellValue;
		dxColumn.filterOperations = filterOperations;

		const isDynamic =
			dataGrid.saveMode === 'self' ||
			(dataGrid.dataSource.name && !dataGrid.dataSource.runAtServer);

		if (isDynamic) {
			dxColumn.calculateFilterExpression = calculateFilterExpressionDynamic;
		} else {
			dxColumn.calculateFilterExpression = calculateFilterExpression;
		}
	}
};
